// extracted by mini-css-extract-plugin
module.exports = {"GeneralRules":"GeneralRules_GeneralRules__1HA97","pageTitle":"GeneralRules_pageTitle__1pZmx"};